import ResizeImg from '@/components/ResizeImage'
import React, { memo } from 'react'
import styles from './index.module.scss'
interface ChildProps {
  coinLogoUrl: string
  networkLogoUrl?: string
  coinName: string
  coinFullName: string
}

const CoinImgName = memo<ChildProps>(props => {
  const { coinLogoUrl, networkLogoUrl, coinName, coinFullName } = props

  return (
    <div className={styles.coin_img_name}>
      <div
        className={styles.coin_img}
        style={{
          backgroundImage: `url(${coinLogoUrl}?x-oss-process=image/resize,m_fill,h_28,w_28)`,
        }}
      >
        {networkLogoUrl && <ResizeImg src={networkLogoUrl} size="12x12" />}
      </div>
      <div className={styles.coin_name}>
        <p>{coinName}</p>
        <span>{coinFullName}</span>
      </div>
    </div>
  )
})

export default CoinImgName
